export default __webpack_public_path__ + "static/media/information--built-up-area--g2.11ebb081.png";